import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CardPreview from '../common/CardPreview';
const ApproachCard = () => {
    return (_jsx(CardPreview, { icon: "faCompass", description: "Process, delivery mindset, and how I adapt across projects.", title: _jsxs(_Fragment, { children: [_jsx("span", { className: "text-text-primary", children: "My" }), '\u00A0', _jsx("span", { className: "text-text-accent", children: "Approach" })] }) }));
};
export default ApproachCard;
